import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { adminUserService } from "../../services/adminUserService";

const AdminUserView: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState<any | null>(null);

  useEffect(() => {
    if (!id) return;
    let mounted = true;
    adminUserService.getById(id).then((u) => { if (mounted) setUser(u); }).catch((e) => {
      console.error(e);
      alert("Failed to load user");
    });
    return () => { mounted = false; };
  }, [id]);

  const handleDelete = async () => {
    if (!id) return;
    if (!window.confirm("Delete this user? This cannot be undone.")) return;
    try {
      await adminUserService.remove(id);
      alert("User deleted");
      navigate("/admin/users");
    } catch (err) {
      console.error(err);
      alert("Failed to delete user");
    }
  };

  if (!user) return <div className="admin-container"><p>Loading user...</p></div>;

  return (
    <div className="admin-container">
      <h2 className="admin-header">View Admin User</h2>
      <div className="card">
        <p><strong>Name:</strong> {user.name}</p>
        <p><strong>Email:</strong> {user.email}</p>
        <p><strong>Role:</strong> {user.role}</p>
      </div>

      <div style={{ marginTop: 12 }}>
        <Link to={`/admin/users/edit/${user.id}`} className="adminAddButton">Edit</Link>
        <button onClick={handleDelete} style={{ marginLeft: 8 }} className="adminAddButton">Delete</button>
        <Link to="/admin/users" style={{ marginLeft: 8 }}>Back to list</Link>
      </div>
    </div>
  );
};

export default AdminUserView;
